import React from 'react';
import { BookButton } from './BookButton';
export function MobileBookingBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/40 bg-navy/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden" data-id="element-81" data-mp="1uh2x364tkg11">
      <BookButton fullWidth data-id="element-82" data-mp="28dzll0xgtler" />
    </div>;
}